const Builder = require('../BuilderBase');
const Layout = require('../Layout');
module.exports = class TabViewLayout extends Builder {
    constructor(title, properties) {
        super('layout_TabViewLayout', title, properties);
    }

    layout(options) {
        let layout = new Layout('testLayout');
        this.addChildBlock(layout, undefined, options);
        return layout;
    }
};
